import { jsxs as a, jsx as d } from "react/jsx-runtime";
import { useRef as n, useEffect as m } from "react";
import { C as l } from "../icons/Chevron-BBlkokQX.mjs";
const _ = ({
  initialOpen: s = !0,
  children: c,
  heading: o,
  className: t = "",
  lightBackground: e = !1,
  ...i
}) => {
  const r = n(null);
  return m(() => {
    r.current && (r.current.open = s);
  }, [s]), /* @__PURE__ */ a(
    "details",
    {
      ref: r,
      "data-testid": "rds-accordion",
      className: `rds-accordion-details ${e ? "rds-accordion-details--light" : ""} ${e === "white" ? "rds-accordion-details--white" : ""} ${t}`,
      ...i,
      children: [
        /* @__PURE__ */ a("summary", { "data-testid": "rds-accordion-summary", className: "rds-accordion-details__summary", children: [
          /* @__PURE__ */ d(l, {}),
          /* @__PURE__ */ d("div", { className: "rds-accordion-details__summary__content", children: o })
        ] }),
        c
      ]
    }
  );
};
export {
  _ as A
};
